module.exports = __webpack_public_path__ + "img/head_bg@2x.6668cd99.png";